// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dost-button {
  position: relative;
  overflow: hidden;
  isolation: isolate;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  padding: 0 1.35rem;
  border-radius: 8px;
  text-decoration: none !important;
  background: #0b2f6b;
  color: #ffffff;
  font-family: "Lexend", system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;
  font-size: 1.2rem;
  font-weight: 800;
  letter-spacing: 0.01em;
  box-shadow: 0 10px 22px rgba(11, 47, 107, 0.38);
  transition: transform 180ms ease, box-shadow 220ms ease, filter 220ms ease;
  z-index: 1;
}

.dost-button::before {
  content: "";
  position: absolute;
  top: -140%;
  left: -30%;
  width: 60%;
  height: 320%;
  transform: rotate(20deg);
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.45), transparent);
  transition: left 420ms ease;
  pointer-events: none;
  border-radius: inherit;
}

.dost-button:hover {
  transform: translateY(-1px) scale(1.02);
  box-shadow: 0 0 0 2px rgba(41, 121, 255, 0.2), 0 12px 26px rgba(11, 47, 107, 0.35),
    0 8px 18px rgba(11, 47, 107, 0.45);
  filter: saturate(1.08);
}

.dost-button:hover::before {
  left: 120%;
}

.dost-button:focus-visible {
  outline: none;
  border-radius: 8px;
  box-shadow: 0 0 0 3px rgba(41, 121, 255, 0.3), 0 10px 22px rgba(11, 47, 107, 0.38);
}

.dost-button:hover,
.dost-button:focus,
.dost-button:active,
.dost-button:visited {
  text-decoration: none !important;
  color: #ffffff;
}

.dost-button:focus {
  outline: none;
  border-radius: 8px;
}

.dost-button:active {
  border-radius: 8px;
  transform: translateY(0) scale(0.99);
}

@media (max-width: 1023px) {
  .dost-button {
    order: 1;
    height: 44px;
    padding: 0 1.05rem;
    border-radius: 8px;
    font-size: 0.92rem;
    box-shadow: 0 6px 14px rgba(11, 47, 107, 0.3);
  }
}
`, "",{"version":3,"sources":["webpack://./dost/dost-button.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;EACd,oFAAoF;EACpF,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,+CAA+C;EAC/C,0EAA0E;EAC1E,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,UAAU;EACV,YAAY;EACZ,wBAAwB;EACxB,uFAAuF;EACvF,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC;sCACoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kFAAkF;AACpF;;AAEA;;;;EAIE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,QAAQ;IACR,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,6CAA6C;EAC/C;AACF","sourcesContent":[".dost-button {\n  position: relative;\n  overflow: hidden;\n  isolation: isolate;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 50px;\n  padding: 0 1.35rem;\n  border-radius: 8px;\n  text-decoration: none !important;\n  background: #0b2f6b;\n  color: #ffffff;\n  font-family: \"Lexend\", system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;\n  font-size: 1.2rem;\n  font-weight: 800;\n  letter-spacing: 0.01em;\n  box-shadow: 0 10px 22px rgba(11, 47, 107, 0.38);\n  transition: transform 180ms ease, box-shadow 220ms ease, filter 220ms ease;\n  z-index: 1;\n}\n\n.dost-button::before {\n  content: \"\";\n  position: absolute;\n  top: -140%;\n  left: -30%;\n  width: 60%;\n  height: 320%;\n  transform: rotate(20deg);\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.45), transparent);\n  transition: left 420ms ease;\n  pointer-events: none;\n  border-radius: inherit;\n}\n\n.dost-button:hover {\n  transform: translateY(-1px) scale(1.02);\n  box-shadow: 0 0 0 2px rgba(41, 121, 255, 0.2), 0 12px 26px rgba(11, 47, 107, 0.35),\n    0 8px 18px rgba(11, 47, 107, 0.45);\n  filter: saturate(1.08);\n}\n\n.dost-button:hover::before {\n  left: 120%;\n}\n\n.dost-button:focus-visible {\n  outline: none;\n  border-radius: 8px;\n  box-shadow: 0 0 0 3px rgba(41, 121, 255, 0.3), 0 10px 22px rgba(11, 47, 107, 0.38);\n}\n\n.dost-button:hover,\n.dost-button:focus,\n.dost-button:active,\n.dost-button:visited {\n  text-decoration: none !important;\n  color: #ffffff;\n}\n\n.dost-button:focus {\n  outline: none;\n  border-radius: 8px;\n}\n\n.dost-button:active {\n  border-radius: 8px;\n  transform: translateY(0) scale(0.99);\n}\n\n@media (max-width: 1023px) {\n  .dost-button {\n    order: 1;\n    height: 44px;\n    padding: 0 1.05rem;\n    border-radius: 8px;\n    font-size: 0.92rem;\n    box-shadow: 0 6px 14px rgba(11, 47, 107, 0.3);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
